import React from 'react';
import { useBusinessMultiKey } from './BusinessMultiSelect';
import { selectedBusinessesText } from '../utils/selectedBusinessesText';

// Large header label naming what the switcher has selected. Re-renders the
// moment the multi-selection or the single selection changes.
export default function SelectedBusinessesLabel({ locations, selectedBusiness, color }) {
  const multiKey = useBusinessMultiKey();
  const ids = multiKey ? multiKey.split(',').map(Number) : (selectedBusiness ? [Number(selectedBusiness)] : []);
  const { text, full } = selectedBusinessesText(ids, locations || []);
  return (
    <p data-testid="selected-businesses" title={full} aria-label={`Selected: ${full}`}
      className="text-xl sm:text-2xl lg:text-3xl font-bold leading-tight truncate max-w-full"
      style={{ color: color || '#1F2937' }}>
      {text}
    </p>
  );
}
